import config from 'constants/config'

export const getChannelMarkup = (state: App.State) => config.ENABLE_CHANNEL_MARKUP ? state.marketing.channelMarkup : undefined
